import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './reset.less';

export default Element;
